import React, { useState } from 'react';
import clicksound from '../components/music/click.mp3';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const ModalNameInput = ({ show, onClose, onSave }) => {
    const { t } = useTranslation();
    const [player1Name, setPlayer1Name] = useState('');
    const [player2Name, setPlayer2Name] = useState('');

    const handleSave = () => {
        const audio = new Audio(clicksound);
        audio.play(); 

        onSave(player1Name, player2Name);
        onClose();
    };

    if (!show) {
        return null;
    }

    const handleNameChange = (setter) => (e) => {
        if (e.target.value.length <= 6) {
            setter(e.target.value);
        }
    };

    const isSaveDisabled = !player1Name || !player2Name;

    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-2xl shadow-lg py-10 px-5 sm:py-8 max-w-sm w-full relative">
          <h2 className="text-center text-blue-500 text-2xl sm:text-xl font-bold mb-4">
            {t("enter_player_name")}
          </h2>
          <div className="space-y-3 mb-4 flex flex-col">
            <input
              className="block w-full bg-cyan-100 rounded-full px-4 py-2 text-center placeholder-gray-500"
              placeholder={t("player_1")}
              type="text"
              value={player1Name}
              onChange={handleNameChange(setPlayer1Name)}
            />
            <input
              className="block w-full bg-cyan-100 rounded-full px-4 py-2 text-center placeholder-gray-500"
              placeholder={t("player_2")}
              type="text"
              value={player2Name}
              onChange={handleNameChange(setPlayer2Name)}
            />
          </div>
          <button
            className="button-save block text-white w-full font-bold py-2 px-4 rounded-full shadow-lg transition-all duration-200 ease-in-out"
            onClick={handleSave}
            disabled={isSaveDisabled}
          >
            {t("save")}
          </button>
        </div>
      </div>
    );
};

export default ModalNameInput;
